import React, { createContext, useState } from "react";
import Product from "./Product";
import { PRODUCT } from "./products";

export const ShopContext = createContext(null);
const Context = (props) => {
  const getDefaultCart = () => {
    let cart = {};
    for (let i = 1; i < PRODUCT.length + 1; i++) {
      cart[i] = 0;
    }
    return cart;
  };
  const [cartItems, setCartItems] = useState(getDefaultCart);

  const getTotalCartAmount = ()=>{
    let totalAmount = 0;
    for(const item in cartItems){
        if(cartItems[item] > 0){
            let itemInfo = PRODUCT.find((Product)=>Product.id === Number(item))
            totalAmount += cartItems[item]* itemInfo.price
        }
    }
    return totalAmount
  }
  const addToCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
  };

  

  const removeToCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
  };
  const contextValue = { setCartItems,getTotalCartAmount, cartItems, addToCart, removeToCart };
 

  return (
    <ShopContext.Provider value={contextValue}>
    
      {props.children}
    </ShopContext.Provider>
  );
};

export default Context;
